import { differenceInCalendarDays, parseISO, startOfDay } from "date-fns";
import type { EventTense } from "web_myplann/NotificationCenter/EventAlert/types";

/**
 * Calendar days from today to the event date. Positive = future, 0 = today,
 * negative = past. Uses calendar-day boundaries (not 24h spans) so a date-only
 * input is not shifted by the current time of day.
 */
export const getDaysUntilEvent = (
	eventDate: string,
	today: Date = new Date(),
): number =>
	differenceInCalendarDays(startOfDay(parseISO(eventDate)), startOfDay(today));

export const getEventTense = (
	eventDate: string,
	today: Date = new Date(),
): EventTense => {
	const days = getDaysUntilEvent(eventDate, today);
	if (days > 0) return "future";
	if (days === 0) return "today";
	return "past";
};

/**
 * Lower = more urgent. Overdue events sort above today's, which sort above
 * upcoming ones; the closest dates come first within each group.
 */
export const getEventUrgencyScore = (
	eventDate: string,
	today: Date = new Date(),
): number => getDaysUntilEvent(eventDate, today);
